import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  lastUpdated: Date;
  constructor() { }

  ngOnInit(): void {
    this.lastUpdated = new Date('01/13/2024') //04 Jan 2024;
  }

}
